var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIconBig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upload-icon-big",
    transform: "translate(-90 -25.506)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1226",
    "data-name": "Rectangle 1226",
    width: 128,
    height: 128,
    transform: "translate(90 25.506)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5050",
    "data-name": "Path 5050",
    d: "M1,68.667A34.644,34.644,0,0,1,17.343,39.233a42.672,42.672,0,0,1,84.648,0,34.672,34.672,0,0,1-15.657,64l-53.333.1A34.836,34.836,0,0,1,1,68.667ZM85.524,92.6a24,24,0,0,0,10.82-44.313l-4.3-2.681-.638-5.024a32.005,32.005,0,0,0-63.485,0L27.286,45.6l-4.3,2.681A24,24,0,0,0,33.809,92.6l.924.07H84.6ZM65,60.667V82H54.333V60.667h-16L59.667,34,81,60.667Z",
    transform: "translate(94.333 34.173)",
    fill: "#ebf7fb",
    stroke: "#f5fbfc",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIconBig);
export default __webpack_public_path__ + "static/media/upload-icon-big.98567e8ca9aa5ec99eda7f59e62b263e.svg";
export { ForwardRef as ReactComponent };